<ng-container *ngIf="!isGameWon && !isGameLost">

  <div class="top mb-2">

    <div class="current-letter-container">
      <span class="current-letter">{{ currentLetter }}</span>
    </div>

    <div [style.background-image]="getPieColor()" class="pie"></div>
  </div>

  <div class="cells mb-2">
    <div *ngFor="let cell of cells" class="cell">
      {{ cell.display }}
    </div>
  </div>
  <div></div>

  <!--{{ I18ns.wheel.history }}-->
  <!--<div class="history">-->
  <!--  <div *ngFor="let letter of history">{{ letter }}</div>-->
  <!--</div>-->

  <p class="counter mb-2">{{ I18ns.grid.words }} ({{ wordIndex + "/" + dictionary.length }})</p>

  <app-keyboard (key)="keyPressed($event)" [greyedKeys]="history"></app-keyboard>
</ng-container>

<div *ngIf="isGameLost" class="game-finished">
  <h2>
    {{ I18ns.grid.tooBad }}
  </h2>
  <p>
    {{ I18ns.grid.gameLost }}
  </p>
  <p class="answer">
    {{ store.word() }}
  </p>

  <p>&nbsp;</p>

</div>

<div *ngIf="isGameWon" class="game-finished">
  <h2>
    {{ I18ns.grid.congratulations }}
  </h2>
  <p>
    {{ I18ns.grid.finished }}
  </p>

  <p>&nbsp;</p>
  <app-themes></app-themes>

</div>
